export default "__VITE_ASSET__wUyCP5r4__"